<template>
  <div>
    <label class="label">{{filterTitle}}</label>
    <div class="filter">
      <vue-datepicker-local v-on:input="emitDateSelected" :disabledDate="disabledDate" :value="selectedDate" :class="sizeClass" :local="local" :format="formatDate" />
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import VueDatepickerLocal from 'vue-datepicker-local';
import {eventBus} from '@/main';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import {mapGetters} from 'vuex';

export default {
  props: {
    dateId: {
      type: String
    },
    filterTitle: {
      type: String
    },
    formatDate: {
      type: String,
      default: 'YYYY'
    },
    startDate: {
      type: String
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  components: {
    FontAwesomeIcon,
    VueDatepickerLocal
  },
  data () {
    return {
      time: new Date(this.startDate),
      range: [new Date(), new Date()],
      emptyTime: '',
      emptyRange: []
    };
  },
  created () {
    dayjs.extend(localeData);
    dayjs().localeData();
  },
  methods: {
    emitDateSelected (payload) {
      eventBus.$emit('dateSelected', { date: payload, id: this.dateId });
    },
    getMonths () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.months();
      return months.map(month => this.capitalize(month));
    },
    getMonthsShort () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const months = dayjs.monthsShort();
      return months.map(month => this.removeLastCharacter(this.capitalize(month)));
    },
    getWeekDays () {
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      const days = dayjs.weekdaysShort(true);
      return days.map(day => this.removeLastCharacter(this.capitalize(day)));
    },
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    removeLastCharacter (str) {
      return str.substring(0, str.length - 1);
    }
  },
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    selectedDate () {
      return new Date(this.startDate);
    },
    sizeClass () {
      let computedSizeClass = '';
      if (this.formatDate !== 'YYYY') {
        computedSizeClass = 'wide-size';
      }
      if (this.formatDate !== 'MMMM YYYY' && this.formatDate !== 'YYYY') {
        computedSizeClass = 'extra-wide-size';
      }
      return computedSizeClass;
    },
    angleDown () {
      return faAngleDown;
    },
    local () {
      return {
        dow: this.getLanguageCode === 'es' ? 1 : 0,
        hourTip: this.$t('filter.hour'), // tip of select hour
        minuteTip: this.$t('filter.minute'), // tip of select minute
        secondTip: this.$t('filter.second'), // tip of select second
        yearSuffix: '', // suffix of head year
        monthsHead: this.getMonths(), // months of head
        months: this.getMonthsShort(), // months of panel
        weeks: this.getWeekDays(), // weeks
        cancelTip: this.$t('filter.cancel'),
        submitTip: this.$t('filter.submit')
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.label {
  margin-right: $sp-margin-smaller;
  @media (max-width: $screen-l-max) {
    display: block;
    margin-bottom: $sp-margin-smaller;
  }
}
.filter {
  @media (max-width: $screen-l-max) {
    width: 100%;
    margin-bottom: $sp;
  }
}
.filter-date {
  background-color: $black-trans7;
  border: 1px solid $white-trans6;
  border-radius: $radius;
  color: $white;
  width: 100%;
  [controlsBg="light"] & {
    color: $bodycolor;
    background-color: $white;
    border: 1px solid $black-trans6;
  }
}

.topbar-dropdown {
  color: $bodycolor-inverse;
  margin-left: $sp;
  font-weight: 800;
  [controlsBg="light"] & {
    color: $bodycolor;
  }

  svg {
    margin-left: $sp-margin-smaller;
    transform: scale(0.875);
    transform-origin: bottom;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/controlsbar/ControlsFilter.vue